import React from 'react';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export default React.forwardRef<HTMLInputElement, InputProps>(({ ...rest }, ref) => {
    return <input ref={ref} {...rest} />;
});